<template lang="pug">
div#app-container
  div#app-wrapper
    Header
    .main-content.has-navbar-fixed-top.height-100
      .wrapper.has-navbar-fixed-top.height-100
        router-view
  Footer
</template>
<script>
import Header from "@/new-components/Header.vue";
import Footer from "@/new-components/Footer.vue";
export default {
  components: {
    Header,
    Footer
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding-top: 50px;
}
</style>
